import { combineReducers } from "redux";
import postReducer from "./post/post.reducer";
import userReducer from "./user/user.reducer";
import jobReducer from "./job/job.reducer";

const rootReducer = combineReducers({
  user: userReducer,
  post: postReducer,
  job: jobReducer,
});

export default rootReducer;